<app-header></app-header>
<main class="main-content">
   <!------main-content------>
   <!-----------page_title--------------->
   <section class="page_title  pdt_80  pdb_40 min-height-auto" style="padding-bottom: 0px;">
      <div class="container">
         <div class="row">
            <!---------row----------->

            <!----------row-end---------->
         </div>
      </div>
   </section>
   <!-----------page_title-end-------------->
   <!-----------footer--------------->
   <section class="contact_page pdb_70 pdt_50">
      <div class="container">
         <div class="row">
            <!---------row----------->
            <div class="col-lg-6 pb-3 shadow mx-auto text-center">
                <h1 class="pt-5">Payment Successful</h1>
                <img src="assets/image/icon/payment-done.png" class="img-fluid" >
                <br>
                <img src="assets/image/icon/muni.png" class="mt-2">
                <p class="font-13 line-height-18">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            
            </div>

            

            <!---------col-end---------->
         </div>

         

      </div>
   </section>
   <app-footer></app-footer>

</main>
<app-scrolltotop></app-scrolltotop>